module.exports = __webpack_public_path__ + "img/73d62f2.jpg";